import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/subscriber`;

async function uploadProfilePhoto(formData, token) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  const configMultiForm = {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  return axios
    .post(`${BASE_URL}/photo`, formData, configMultiForm)
    .then(async ({ data }) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
}

async function setUsername(username, token) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  return axios
    .post(`${BASE_URL}/username`, { username })
    .then(async ({ data }) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
}

async function fetchUserProfile(token) {
  //updating Headers
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  return axios
    .get(`${BASE_URL}/profile`)
    .then(async ({ data }) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
}

async function fetchUserInfo(msisdn) {
  try {
    const { data } = await axios.get(`${BASE_URL}/fetchuser/${msisdn}`);
    return data;
  } catch (e) {
    throw e;
  }
}

async function updateUserData(userData) {
  try {
    const { data } = await axios.post(`${BASE_URL}/updateuserdata`, userData);

    return data;
  } catch (e) {
    throw e;
  }
}

async function saveUserData(userData) {
  try {
    const { data } = await axios.post(`${BASE_URL}/savedata`, userData);

    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  uploadProfilePhoto,
  updateUserData,
  fetchUserInfo,
  saveUserData,
  setUsername,
  fetchUserProfile,
};
